<template>
  <div class="worktime-item">
    <div class="worktime-item__day">
      {{ $t(`shared.unit.day.${item.day}.short`) }}
    </div>

    <div class="worktime-item__times">
      <span v-for="t in item.items" :key="t.id" class="worktime-item__button">
        {{ t.start }} - {{ t.end }}
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    }
  };
</script>

<style lang="scss">
  .worktime-item {
    display: flex;
    align-items: center;

    & + & {
      margin-top: 10px;
    }

    &__day {
      width: 35px;
      margin-right: 5px;
    }

    &__times {
      display: flex;
      flex-direction: column;
    }

    &__button {
      display: inline-block;
      margin-bottom: 0;
      text-align: center;
      vertical-align: middle;
      border: 1px solid $grey-dark;
      white-space: nowrap;
      line-height: 1.5;
      user-select: none;
      color: $blue-grey-dark;
      background-color: $grey-light;
      padding: 1px 7px 2px;
      font-size: 12px;
      border-radius: 4px;

      & + & {
        margin-top: 5px;
      }
    }
  }
</style>
